import Vue from 'vue';
import Router from 'vue-router';
import loading from '@/components/loading';
import welcome from '@/components/welcome';
import homepage from '@/components/homepage';
import game from '@/components/game';
import share from '@/components/share';
import lottery from '@/components/lottery';
import form from '@/components/form';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: '/loading'
        },
        {
            path: '/loading',
            name: 'loading',
            component: loading
        },
        {
            path: '/welcome',
            name: 'welcome',
            component: welcome
        },
        {
            path: '/homepage',
            name: 'homepage',
            component: homepage
        },
        {
            path: '/game',
            name: 'game',
            component: game
        },
        {
            path: '/share',
            name: 'share',
            component: share
        },
        {
            path: '/lottery',
            name: 'lottery',
            component: lottery
        },
        {
            path: '/form',
            name: 'form',
            component: form
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (!window.hasLoaded) {
        window.hasLoaded = true;
        next({
            path: '/',
            replace: true
        });
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js